import Logo from '@/components/logo/logo';
import { REFRESH_TOKEN } from '@/utils/utils';
import { IS_DESKTOP } from '@/config/platform';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useEffect, useMemo, useState } from 'react';

export const Route = createFileRoute('/')({
  component: Index,
});

function Index() {
  const isLoggedIn = useMemo(() => window.store.get(REFRESH_TOKEN), []);
  const [loading, setLoading] = useState(IS_DESKTOP);

  useEffect(() => {
    if (!loading) return;
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timeout);
  }, [loading]);

  if (loading) {
    return (
      <div className="page-container h-dvh items-center justify-center">
        <Logo simple size={100} className="animate-pulse" />
      </div>
    );
  }

  return <Navigate to={isLoggedIn ? '/dashboard/accounts' : '/auth'} />;
}
